import { z } from "@/zod";
import {
  readAgreement,
  writeAgreement,
  agreementFormSchema,
} from "@/schemas/agreement";

export const AGREEMENT_STATUSES = {
  QUESTIONNAIRE_TO_FILL: "questionnaire_to_fill",
  QUESTIONNAIRE_TO_VERIFY: "questionnaire_to_verify",
  QUESTIONNAIRE_TO_CORRECT: "questionnaire_to_correct",
  AGREEMENT_CONFIRMED: "agreement_confirmed",
  AGREEMENT_REJECTED: "agreement_rejected",
  AGREEMENT_REJECTED_BY_CONTRACTOR: "agreement_rejected_by_contractor",
  AGREEMENT_COMPLETED: "agreement_completed",
  AGREEMENT_AMEND_DATA: "agreement_amend_data",
  AGREEMENT_AMEND_TAX_STATUS: "agreement_amend_tax_status",
  AGREEMENT_AMEND_STATEMENTS: "agreement_amend_statements",
  AGREEMENT_UPDATE_CONTENT: "agreement_update_content",
} as const;

export const AGREEMENT_STATUS = Object.values(AGREEMENT_STATUSES) as [
  string,
  ...string[],
];

export type AgreementStatus = (typeof AGREEMENT_STATUS)[number];

export type ReadAgreement = z.infer<typeof readAgreement>;
export type WriteAgreement = z.infer<typeof writeAgreement>;
export type UpdateAgreement = z.infer<typeof writeAgreement>;
export type AgreementFormData = z.infer<typeof agreementFormSchema>;

export interface AgreementField {
  key: string;
  type?: "boolean" | "textarea" | "attachments";
  group?: string;
  valueTranslationPrefix?: string;
  showExpiredWarning?: boolean;
  formatValue?: (
    value: unknown,
    data: Record<string, unknown>,
    t: (key: string) => string,
  ) => string;
}

export type AgreementFields = readonly AgreementField[];
